import React from "react";
import FieldHeader from "./FieldHeader";
import Switch from "react-switch";
import UserfulTooltip from "../Widgets/UserfulTooltip";

interface IProps {
    check: boolean;
    name: string;
    description: string;
    className?: string;
    handleClick?: any;
    disabled?: boolean;
    overlayDes?: string;
}

export const CustomSwitch = (props: IProps) => {
    const switchDiv = () => {
        return (
            <div
                className={`custom-switch-main-wrapper ${props.check ? "selectInput" : ""} ${props.disabled ? "disableCustomSwitch" : ""} ${props.className ?? ""}`}
                onClick={props.disabled ? () => {} : props.handleClick}
            >
                <FieldHeader name={props.name} description={props.description} />
                <div className="custom-toggle-switch-wrapper">
                    <Switch
                        onChange={(e) => {}}
                        checked={props.check}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={16}
                        width={28}
                        onHandleColor="#FFFFFF"
                        onColor="#23A866"
                        offColor="#C6C8CE"
                        offHandleColor="#FFFFFF"
                        className="toggle-switch"
                        disabled={props.disabled}
                    />
                </div>
            </div>
        );
    };

    if (props.overlayDes) {
        return <UserfulTooltip title={props.overlayDes}>{switchDiv()}</UserfulTooltip>;
    }
    return switchDiv();
};

export default CustomSwitch;
